module.exports = __webpack_public_path__ + "static/img/Ten of Pentacles.78434ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Ten of Pentacles.jpg
// module id = 1305
// module chunks = 0